export default __webpack_public_path__ + "static/media/description-text.e456701d.png";